'use strict';

module.exports = require('./_ajax');
